import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { Table, TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { ProductService } from '../../pages/service/product.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CustomerService } from '../../pages/service/customer.service';
import { DropdownModule } from 'primeng/dropdown';
import { AnnuaireServiceService } from '../../services/annuaire-service/annuaire.service';
import { FileUploadModule } from 'primeng/fileupload';
import { Router } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { SelectButtonModule } from 'primeng/selectbutton';

interface Column {
  field: string;
  header: string;
  customExportHeader?: string;
}

interface ExportColumn {
  title: string;
  dataKey: string;
}

interface expandedRows {
  [key: string]: boolean;
}
@Component({
  selector: 'app-gestion-annuaire',
  imports: [BreadcrumbModule,
    TableModule,
    FormsModule,
    ButtonModule,
    ToastModule,
    ToolbarModule,
    InputTextModule,
    TextareaModule,
    SelectModule,
    RadioButtonModule,
    InputNumberModule,
    DialogModule,
    TagModule,
    InputIconModule,
    IconFieldModule,
    ConfirmDialogModule, DropdownModule,
    NgIf, NgClass, NgFor, FileUploadModule, ToggleSwitchModule, SelectButtonModule

  ],
  templateUrl: './gestion-annuaire.component.html',
  styleUrl: './gestion-annuaire.component.scss',
  providers: [ConfirmationService, MessageService, CustomerService, ProductService]

})

export class GestionAnnuaireComponent {

  breadcrumbAnnuaire = {
    icon: 'pi pi-home',
    routerLink: '/rechercher-do',
    styleClass: 'breadcrumb-home'
  };
  breadcrumbItems = [{ label: 'Gestion Annuaire' }];
  services: any;
  annuaires: any;
  DO: any;
  nomDo!: string;
  switchValue!: boolean;
  selectedAnnuaires: any[] | null = null;
  ajoutDialog: boolean = false;
  updateDialog: boolean = false;
  UploadDialog: boolean = false;
  DetailsDialog: boolean = false;
  submitted: boolean = false;
  rowsPerPageOptions: number[] = [10]; // Valeur par défaut
  totalRecords: number = 10;

  annuaire: any;
  exportColumns!: ExportColumn[];
  cols!: Column[];
  rowGroupMetadata: any;
  uploadedFiles: any[] = [];
  loading: boolean = true;
  selectedAnnuaireItem: any;
  nomAjoutInvalide: boolean = false;
  emailAjoutInvalide: boolean = false;
  civiliteAjoutInvalide: boolean = false;
  civiliteModifInvalide: boolean = false;
  nomUpdateInvalide: boolean = false;
  emailUpdateInvalide: boolean = false;
  add_on: any = false;

  statusOptions = [
    { label: 'Activé', value: 1 },
    { label: 'Désactivé', value: 0 }
  ];
  selectButtonValues = [
    { name: 'M.', value: 'M.' },
    { name: 'Mme', value: 'Mme' }
  ];
  buttonDisable = false;
  isDisableMode = false;
  isEnableMode = false;
  @ViewChild('filter') filter!: ElementRef;
  @ViewChild('dt1', { static: false }) dt1!: Table;

  constructor(
    private annuaireService: AnnuaireServiceService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private router: Router,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
    //this.DO = sessionStorage.getItem('selectedDo');
    let selectedDoString = sessionStorage.getItem('selectedDo');
    if (selectedDoString) {
      let selectedDo = JSON.parse(selectedDoString);
      this.DO = selectedDo.code_interne;
      this.nomDo = selectedDo.Nom;

    } else {
      this.router.navigate(['/rechercher-do']);
    }
    this.loadData();
    // this.services = this.annuaires.map((a: { serviceName: string }) => a.serviceName);
    // console.log(this.services)
    this.cols = [
      { field: 'code_interne', header: 'code_interne', customExportHeader: 'Product Code' },
      { field: 'code_DO', header: 'code_DO' },
      { field: 'Nom', header: 'Nom' },
      { field: 'Tel1', header: 'Tel1' },
      { field: 'AdrEmail', header: 'AdrEmail' }
    ];

    this.exportColumns = this.cols.map(col => ({
      title: col.customExportHeader ?? col.header,
      dataKey: col.field
    }));
  }
  loadData() {
    this.annuaireService.getAllAnnuaireByCodeDo(this.DO).subscribe((data: any) => {
      this.annuaires = data;
      this.annuaires = data.map((a: any) => ({
        ...a,
        nomComplet: `${a.Nom} ${a.Prenom}`,
        fonctionService: a.Fonction && a.Service
          ? `${a.Fonction} / ${a.Service}`
          : a.Fonction || a.Service || '',
        switchValue: a.FlagActif === 1
      }));
      this.services = [...new Set(this.annuaires.map((a: any) => a.service))]; // Unique services
      this.totalRecords = data.length;
      this.updateRowsPerPageOptions();
      //console.log(this.annuaires)
      this.loading = false;
    });
  }

  validateAjoutForm(): boolean {
    this.nomAjoutInvalide = !this.annuaire.Nom || this.annuaire.Nom.trim() === '';
    this.civiliteAjoutInvalide = !this.annuaire.Civilite || this.annuaire.Civilite.trim() === '';

    return !(this.nomAjoutInvalide || this.civiliteAjoutInvalide);
  }
  validateUpdateForm(): boolean {
    this.nomUpdateInvalide = !this.annuaire.Nom || this.annuaire.Nom.trim() === '';
    this.civiliteModifInvalide = !this.annuaire.Civilite || this.annuaire.Civilite.trim() === '';

    // this.emailUpdateInvalide = this.annuaire.AdrEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.annuaire.AdrEmail);
    // return !(this.nomUpdateInvalide || this.emailUpdateInvalide);
    return !(this.nomUpdateInvalide || this.civiliteModifInvalide);
  }


  openNew() {
    this.annuaire = {};
    this.submitted = false;
    this.ajoutDialog = true;
  }

  hideDialog() {
    this.ajoutDialog = false;
    this.updateDialog = false;
    this.DetailsDialog = false;
    this.nomAjoutInvalide = false;
    this.emailAjoutInvalide = false;
    this.nomUpdateInvalide = false;
    this.emailUpdateInvalide = false;
    this.submitted = false;
    this.civiliteAjoutInvalide = false;
    this.civiliteModifInvalide = false;
    this.buttonDisable = false;

  }


  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  clear(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }


  calculateCustomerTotal(name: string) {
    let total = 0;

    if (this.annuaires) {
      for (let annuaire of this.annuaires) {
        if (annuaire.service === name) {
          total++;
        }
      }
    }

    return total;
  }

  disableSelectedAnnuaires() {
    this.confirmationService.confirm({
      message: 'Confirmez la désactivation ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.confirmationService.close?.();
        if (!this.selectedAnnuaires || this.selectedAnnuaires.length === 0) {
          console.warn('Aucune sélection');
          return;
        }
        const codes = this.selectedAnnuaires.map(a => a.code_interne);
        this.annuaireService.disableAnnuaire(codes).subscribe(
          (data: any) => {

            this.loadData();
            this.messageService.add({
              severity: 'success',
              summary: 'Réussi',
              detail: `${codes.length} élément(s) désactivé(s)`,
              life: 3000
            });

          });
      },
      reject: () => {
        this.confirmationService.close?.();
      }
    });




  }
  enableSelectedAnnuaires() {
    this.confirmationService.confirm({
      message: 'Confirmez l\'activation  ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.confirmationService.close?.();
        if (!this.selectedAnnuaires || this.selectedAnnuaires.length === 0) {
          console.warn('Aucune sélection');
          return;
        }
        const codes = this.selectedAnnuaires.map(a => a.code_interne);
        this.annuaireService.enableAnnuaire(codes).subscribe(
          (data: any) => {

            this.loadData();
            this.messageService.add({
              severity: 'success',
              summary: 'Réussi',
              detail: `${codes.length} élément(s) activé(s)`,
              life: 3000
            });

          });
      },
      reject: () => {
        this.confirmationService.close?.();
      }
    });

  }
  deleteByOne(annuaire: any) {

    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir supprimer ' + annuaire.Nom + '?',
      header: 'Confirmer',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.confirmationService.close?.();
        this.annuaireService.deleteAnnuaire([annuaire.code_interne]).subscribe(
          (result: any) => {

            this.loadData();
            this.messageService.add({
              severity: 'success',
              summary: 'Réussi',
              detail: `Annuaire ${annuaire.code_interne} supprimé !`,
              life: 3000
            });
          },
          (error) => {
            console.error(error)
          }
        )

      },
      reject: () => {
        this.confirmationService.close?.();
      }
    });
  }


  editAnnuaire(annuaire: any) {
    this.annuaire = { ...annuaire };
    this.updateDialog = true;
  }

  UpdateAnnuaire(code_interne: number, annuaire: any) {
    if (!this.validateUpdateForm()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Champs invalides',
        detail: 'Veuillez corriger les erreurs dans le formulaire.'
      });
      setTimeout(() => {
        this.nomUpdateInvalide = false;
        this.emailUpdateInvalide = false;
      }, 3000); return;
    }
    annuaire = {
      Civilite: this.annuaire.Civilite,
      Nom: this.annuaire.Nom,
      Prenom: this.annuaire.Prenom,
      Adresse1: this.annuaire.Adresse1,
      Adresse2: this.annuaire.Adresse2,
      CodePostal: this.annuaire.CodePostal,
      Ville: this.annuaire.Ville,
      Tel1: this.annuaire.Tel1,
      Tel2: this.annuaire.Tel2,
      Tel3: this.annuaire.Tel3,
      TelPrivate: this.annuaire.TelPrivate,
      TelGSM: this.annuaire.TelGSM,
      Fax: this.annuaire.Fax,
      AdrEmail: this.annuaire.AdrEmail,
      Fonction: this.annuaire.Fonction,
      Service: this.annuaire.Service,
      Assistant: this.annuaire.Assistant,
      Remarque: this.annuaire.Remarque
    };
    this.buttonDisable = true
    this.annuaireService.updateAnnuaire(code_interne, annuaire).subscribe({
      next: () => {
        this.loadData();
        this.buttonDisable = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Succès',
          detail: 'Annuaire mis à jour'
        });
        this.updateDialog = false;
      },
      error: (err) => {
        console.error(err);
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'La mise à jour a échoué' });
      }
    });
  }

  ajouterAnnuaire(annuaire: any) {
    if (!this.validateAjoutForm()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Champs invalides',
        detail: 'Veuillez corriger les erreurs dans le formulaire.'
      });
      setTimeout(() => {
        this.nomAjoutInvalide = false;
        this.emailAjoutInvalide = false;
      }, 3000); return;
    }

    annuaire = {
      code_DO: this.DO,
      Civilite: this.annuaire.Civilite,
      Nom: this.annuaire.Nom,
      Prenom: this.annuaire.Prenom,
      Adresse1: this.annuaire.Adresse1,
      Adresse2: this.annuaire.Adresse2,
      CodePostal: this.annuaire.CodePostal,
      Ville: this.annuaire.Ville,
      Tel1: this.annuaire.Tel1,
      Tel2: this.annuaire.Tel2,
      Tel3: this.annuaire.Tel3,
      TelPrivate: this.annuaire.TelPrivate,
      TelGSM: this.annuaire.TelGSM,
      Fax: this.annuaire.Fax,
      AdrEmail: this.annuaire.AdrEmail,
      Fonction: this.annuaire.Fonction,
      Service: this.annuaire.Service,
      Assistant: this.annuaire.Assistant,
      Remarque: this.annuaire.Remarque
    };
    this.buttonDisable = true
    this.annuaireService.addAnnuaire(annuaire).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Annuaire ajouté' });
        this.ajoutDialog = false;
        this.buttonDisable = false;
        this.loadData();
      },
      error: (err) => {
        console.error(err);
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'L\'ajout a échoué' });
      }
    });
  }

  ExporterAnnuaireCSV() {
    this.annuaireService.exportAnnuaires(this.DO).subscribe({
      next: (blob) => {
        const reader = new FileReader();
        reader.onload = () => {
          const text = reader.result as string;
          const bom = '\uFEFF'; // Byte Order Mark pour UTF-8
          const blobWithBom = new Blob([bom + text], { type: 'text/csv;charset=utf-8;' });

          const a = document.createElement('a');
          const objectUrl = URL.createObjectURL(blobWithBom);
          a.href = objectUrl;
          a.download = `${this.DO}_Export_Annuaires.csv`;
          a.click();
          URL.revokeObjectURL(objectUrl);
          this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Fichier téléchargé' });
        };
        reader.readAsText(blob); // Lire le blob comme texte
      },
      error: (err) => {
        console.error('Erreur lors du téléchargement :', err);
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'L\'export a échoué' });
      },
    });
  }

  openUploadDialog() {
    this.UploadDialog = true;
  }
  closeUploadDialog() {
    this.UploadDialog = false;
  }
  onUpload(event: any, uploader: any) {
    const files = event.files as File[];

    const validCsvFiles = files.filter((file: File) => {
      const isCsv = file.name.toLowerCase().endsWith('.csv');
      if (!isCsv) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Fichier non valide',
          detail: `Le fichier "${file.name}" n'est pas un fichier CSV.`
        });
      }
      return isCsv;
    });

    if (validCsvFiles.length === 0) {
      uploader.clear();
      return;
    }

    let completed = 0;
    let successCount = 0;
    let errorCount = 0;

    for (let file of validCsvFiles) {
      // console.log(this.add_on)
      const checkCompletion = () => {
        completed++;
        if (completed === validCsvFiles.length) {

          uploader.clear();
        }
      };
      this.annuaireService.importCsvAnnuaire(this.DO, this.add_on, file).subscribe({
        next: (event) => {
          if (event instanceof HttpResponse) {
            if (event.status === 201) {
              successCount = successCount + 1
              this.UploadDialog = false
              this.loadData();
              this.messageService.add({
                severity: 'success',
                summary: 'Import terminé',
                detail: `${successCount} fichier(s) importé(s) avec succès.`
              });
            } else {
              errorCount++;
              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: `Fichier "${file.name}" : Échec d’import (code ${event.status}).`
              });
            }
          }
          checkCompletion();
        },
        error: (err) => {
          errorCount++;
          const errorMessage = err?.error?.message?.error || 'Erreur lors de l’import CSV.';
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: `Fichier "${file.name}" : ${errorMessage}`
          });
          checkCompletion();
        }
      });
    }


  }

  telechargerTemplateCSV() {
    this.annuaireService.exportTemplateAnnuaire().subscribe({
      next: (blob) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = `Template_Import_Annuaires.csv`;
        a.click();
        URL.revokeObjectURL(objectUrl);
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Template téléchargé' });
      },
      error: (err) => {
        console.error('Erreur lors du téléchargement :', err);
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Téléchargement échoué' });
      },
    });
  }


  updateRowsPerPageOptions() {
    const baseOptions = [10, 20, 30, 40, 50];

    // Limitez les options supplémentaires à des valeurs raisonnables
    const maxReasonableOption = 100; // Définissez une limite supérieure raisonnable

    if (this.totalRecords > 50) {
      const additionalOptions = [];
      // Ajoutez des options jusqu'à la limite raisonnable ou au totalRecords (le plus petit des deux)
      const upperLimit = Math.min(this.totalRecords, maxReasonableOption);

      for (let i = 100; i <= upperLimit; i += 100) {
        additionalOptions.push(i);
      }

      this.rowsPerPageOptions = [...baseOptions, ...additionalOptions];
    } else {
      this.rowsPerPageOptions = baseOptions;
    }

    // Ajoutez le totalRecords seulement s'il est raisonnable et différent des options existantes
    if (this.totalRecords <= maxReasonableOption &&
      !this.rowsPerPageOptions.includes(this.totalRecords)) {
      this.rowsPerPageOptions.push(this.totalRecords);
    }
  }

  openDetailsAnnuaire(annuaire: any) {
    this.selectedAnnuaireItem = annuaire;
    this.DetailsDialog = true;
  }

  onToggleChange(annuaire: any) {
    const originalState = annuaire.FlagActif;


    annuaire.toggleLoading = true;

    // Mise à jour visuelle immédiate
    const newState = originalState === 1 ? 0 : 1;


    const code_interne = [annuaire.code_interne];
    const serviceCall = newState === 1
      ? this.annuaireService.disableAnnuaire([annuaire.code_interne])
      : this.annuaireService.enableAnnuaire([annuaire.code_interne]);



    serviceCall.subscribe({
      next: () => {


        this.messageService.add({
          severity: 'success',
          summary: 'Succès',
          detail: `Annuaire ${newState === 1 ? 'désactivé' : 'activé'} avec succès`,
          life: 3000
        });
        this.cd.detectChanges();


      },
      error: (err) => {


        // Rollback



        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: `Une erreur s'est produite lors du changement d'état de l'annuaire.`,
          life: 3000
        });
      },
      complete: () => {
        annuaire.toggleLoading = false;
        this.cd.detectChanges();
      }
    });
  }
  // Méthode pour vérifier si tous les contacts sélectionnés sont activés
  allSelectedAnnuairesActive(): boolean {
    if (!this.selectedAnnuaires || this.selectedAnnuaires.length === 0) {
      return false;
    }
    return this.selectedAnnuaires.every(annuaire => annuaire.FlagActif === 1);
  }

  // Méthode pour vérifier si tous les contacts sélectionnés sont désactivés
  allSelectedAnnuairesInactive(): boolean {
    if (!this.selectedAnnuaires || this.selectedAnnuaires.length === 0) {
      return false;
    }
    return this.selectedAnnuaires.every(annuaire => annuaire.FlagActif === 0);
  }

  // Méthode pour vérifier si la sélection est mixte (actifs et inactifs)
  hasMixedSelection(): boolean {
    if (!this.selectedAnnuaires || this.selectedAnnuaires.length === 0) return false;
    const hasActive = this.selectedAnnuaires.some(annuaire => annuaire.FlagActif === 1);
    const hasInactive = this.selectedAnnuaires.some(annuaire => annuaire.FlagActif === 0);
    return hasActive && hasInactive;
  }
  shouldDisableHeaderCheckbox(): boolean {
    if (this.isDisableMode) {
      return this.annuaires.every((c: any) => c.FlagActif === 0);
    } else if (this.isEnableMode) {
      return this.annuaires.every((c: any) => c.FlagActif === 1);
    }
    return false;
  }

 deleteSelectedAnnuaires() {
    this.confirmationService.confirm({
        message: 'Souhaitez-vous vraiment supprimer les annuaires ?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        rejectButtonStyleClass: 'p-button-secondary',
        acceptLabel: 'Oui',
        rejectLabel: 'Non',
        accept: () => {
            console.log('Bouton cliqué - selected:', this.selectedAnnuaires);

            if (!this.selectedAnnuaires || this.selectedAnnuaires.length === 0) {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Avertissement',
                    detail: 'Aucune annuaire sélectionnée',
                    life: 3000
                });

                this.confirmationService.close();
                return;
            }

            const codes = this.selectedAnnuaires.map(a => a.code_interne);
            this.annuaireService.deleteAnnuaire(codes).subscribe({
                next: () => {
                    this.loadData();
                    this.selectedAnnuaires = [];
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Succès',
                        detail: `${codes.length} annuaire(s) supprimée(s)`,
                        life: 3000
                    });
                     this.confirmationService.close();
                },
                error: (error) => {
                    console.error('Erreur lors de la suppression:', error);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: 'Une erreur est survenue lors de la suppression',
                        life: 3000
                    });
                }
            });
        }
    });
}

}
